<!-- =========================================================================================
  File Name: PageEdit.vue
  Description: Page Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome{margin-bottom: 15px; padding-left: 2px;}
</style>
<template>
  <div id="page-user-edit">
    <div class="header-custome">
      <h3>Add Page</h3>
    </div>
    <vs-alert color="danger" title="Attendee Not Found" :active.sync="page_not_found">
      <span>Page record with id: {{ $route.params.pageeId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="page_data">
      <page-edit-tab-account class="mt-4" :data="page_data" />
    </vx-card>
  </div>
</template>

<script>
import PageEditTabAccount from "./PageEditTabAccount.vue";

// Store Module
import modulePageManagement from "@/store/page-management/modulePageManagement.js";
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
export default {
  components: {
    PageEditTabAccount,
  },
  data() {
    return {
      page_data: null,
      page_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      this.fetch_page_data();
    }
  },
  methods: {
    fetch_page_data() {
      this.$store
        .dispatch("pageManagement/fetchPage", null)
        .then(res => {
          this.$store.dispatch("mailtplManagement/fetchGeneralSettings").then(settings => {
            this.page_data = res.data;
            this.page_data.UnlayerLandingPage = settings.UnlayerLandingPage ? settings.UnlayerLandingPage : null;
          })
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.page_not_found = true;
            return;
          }
          console.error(err);
        });
    }
  },
  created() {
    //debugger;
    // Register Module UserManagement Module
    if (!modulePageManagement.isRegistered) {
      this.$store.registerModule("pageManagement", modulePageManagement);
      modulePageManagement.isRegistered = true;
    }
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }
    this.fetch_page_data(this.$route.params.pageId);
  }
};
</script>